import { render, staticRenderFns } from "./form_edit.vue?vue&type=template&id=58860cb7&scoped=true&"
import script from "./form_edit.vue?vue&type=script&lang=js&"
export * from "./form_edit.vue?vue&type=script&lang=js&"
import style0 from "./form_edit.vue?vue&type=style&index=0&id=58860cb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58860cb7",
  null
  
)

export default component.exports